import { RowComponentProps } from "react-window";

import ListChoice from "components/DesignComponents/ListChoice";

const RowComponent = ({
    index,
    dataArray,
    style
}: RowComponentProps<{ dataArray: any }>) => {
    const option = dataArray[index];

    const hasDescription = Array.isArray(option.children);

    return (
        <ListChoice
            {...option}
            title={
                hasDescription
                    ? option.children[0].props.children
                    : option.children
            }
            description={
                hasDescription
                    ? `ID: ${option.children[1].props.children}`
                    : undefined
            }
            isNormalWhiteSpace
            isCheckbox={!hasDescription}
            selected={!hasDescription && option["aria-selected"]}
            outerStyle={style}
            style={{
                padding: "12px 16px"
            }}
        />
    );
};

export default RowComponent;
